import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-router-dom";
import { FormControl, Modal } from "react-bootstrap";
import TemplatesEditInline from "./TemplatesEditInline";
import TemplatesNewInline from "./TemplatesNewInline";
import SMSTemplatesEditInline from "./SMSTemplatesEditInline";
import SMSTemplatesNewInline from "./SMSTemplatesNewInline";
import RVMTemplatesEditInline from "./RVMTemplatesEditInline";
import RVMTemplatesNewInline from "./RVMTemplatesNewInline";
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';

class StepForm extends Component {
  static propTypes = {
    handleSave: PropTypes.func.isRequired,
    handleFetch: PropTypes.func.isRequired,
    handleTooltipforPause: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    delayValue: PropTypes.string.isRequired,
    delayUnit: PropTypes.string.isRequired,
    medium: PropTypes.string.isRequired,
    emailTemplateId: PropTypes.string.isRequired,
    smsTemplateId: PropTypes.string.isRequired,
    postcardTemplateId: PropTypes.string.isRequired,
    rookeryEnabled: PropTypes.bool.isRequired,
    templates: PropTypes.array,
    smsTemplates: PropTypes.array,
    rvmTemplates: PropTypes.array,
    stepEnabled: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    medium_data: PropTypes.object,
    postcard_templates: PropTypes.array,
    senders: PropTypes.array.isRequired,
    handleTooltipForPause: PropTypes.func.isRequired,
    formKey: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    let purpose,
      description,
      assignee,
      pause;
    let title = "Followup";
    if (
      this.props.medium_data !== null &&
      this.props.medium_data !== undefined
    ) {
      purpose = this.props.medium_data.medium_purpose;
      description = this.props.medium_data.medium_description;
      title = this.props.medium_data.medium_title;
      assignee = this.props.medium_data.medium_assignee;
      pause = this.props.medium_data.medium_pause;
    }
    this.state = {
      id: this.props.id,
      delay_value: this.props.delayValue,
      delay_unit: this.props.delayUnit,
      email_template_id: this.props.emailTemplateId,
      sms_template_id: this.props.smsTemplateId,
      rvm_template_id: this.props.rvmTemplateId,
      postcard_template_id: this.props.postcardTemplateId,
      medium: this.props.medium,
      medium_purpose: purpose,
      medium_description: description,
      medium_title: title,
      medium_assignee: assignee,
      medium_pause: pause,
      showEditActionModal: false,
      showNewActionModal: false,
      showSMSEditActionModal: false,
      showSMSNewActionModal: false,
      showRVMEditActionModal: false,
      showRVMNewActionModal: false
    };
  }

  componentDidMount() {
    this.delayedCallback = _.debounce(function(callback) {
      callback();
    }, 500);
  }

  // Email New/Edit Modals

  closeEditActionModal() {
    this.setState({ showEditActionModal: false });
  }

  openEditActionModal() {
    this.setState({ showEditActionModal: true });
  }

  openEditAction(e) {
    e.preventDefault();
    this.openEditActionModal();
  }

  closeNewActionModal() {
    this.setState({ showNewActionModal: false });
  }

  openNewActionModal() {
    this.setState({ showNewActionModal: true });
  }

  openNewAction(e) {
    e.preventDefault();
    this.openNewActionModal();
  }

  // SMS New/Edit Modals

  closeSMSEditActionModal() {
    this.setState({ showSMSEditActionModal: false });
  }

  openSMSEditActionModal() {
    this.setState({ showSMSEditActionModal: true });
  }

  openSMSEditAction(e) {
    e.preventDefault();
    this.openSMSEditActionModal();
  }

  closeSMSNewActionModal() {
    this.setState({ showSMSNewActionModal: false });
  }

  openSMSNewActionModal() {
    this.setState({ showSMSNewActionModal: true });
  }

  openSMSNewAction(e) {
    e.preventDefault();
    this.openSMSNewActionModal();
  }

  // RVM New/Edit Modals

  closeRVMEditActionModal() {
    this.setState({ showRVMEditActionModal: false });
  }

  openRVMEditActionModal() {
    this.setState({ showRVMEditActionModal: true });
  }

  openRVMEditAction(e) {
    e.preventDefault();
    this.openRVMEditActionModal();
  }

  closeRVMNewActionModal() {
    this.setState({ showRVMNewActionModal: false });
  }

  openRVMNewActionModal() {
    this.setState({ showRVMNewActionModal: true });
  }

  openRVMNewAction(e) {
    e.preventDefault();
    this.openRVMNewActionModal();
  }

  // Task Edit Modals

  closeTaskEditActionModal() {
    this.setState({ showTaskEditActionModal: false });
  }

  openTaskEditActionModal() {
    this.setState({ showTaskEditActionModal: true });
  }

  openTaskEditAction(e) {
    e.preventDefault();
    this.openTaskEditActionModal();
  }

  saveStep() {
    let medium_data = null;
    if (this.state.medium == "manual") {
      medium_data = {
        medium_title: this.state.medium_title,
        medium_purpose: this.state.medium_purpose,
        medium_description: this.state.medium_description,
        medium_assignee: this.state.medium_assignee,
        medium_pause: this.state.medium_pause
      };
    }
    let step = {
      id: this.state.id,
      delay_value: this.state.delay_value,
      delay_unit: this.state.delay_unit,
      medium: this.state.medium,
      medium_data: medium_data,
      email_template_id: this.state.email_template_id,
      sms_template_id: this.state.sms_template_id,
      rvm_template_id: this.state.rvm_template_id,
      postcard_template_id: this.state.postcard_template_id,
      isNew: false
    };
    this.props.handleSave(step);
  }

  updateEmailTemplateId(email_template_id) {
    const { stepEnabled } = this.props;
    this.setState(
      { email_template_id: email_template_id },
      function() {
        if (stepEnabled) {
          this.saveStep();
        } else {
          this.props.handleFetch();
        }
      }.bind(this)
    );
    this.closeNewActionModal();
    this.closeEditActionModal();
  }

  updateSMSTemplateId(sms_template_id) {
    const { stepEnabled } = this.props;
    this.setState(
      { sms_template_id: sms_template_id },
      function() {
        if (stepEnabled) {
          this.saveStep();
        } else {
          this.props.handleFetch();
        }
      }.bind(this)
    );
    this.closeSMSNewActionModal();
    this.closeSMSEditActionModal();
  }

  updateRVMTemplateId(rvm_template_id) {
    const { stepEnabled } = this.props;
    this.setState(
      { rvm_template_id: rvm_template_id },
      function() {
        if (stepEnabled) {
          this.saveStep();
        } else {
          this.props.handleFetch();
        }
      }.bind(this)
    );
    this.closeRVMNewActionModal();
    this.closeRVMEditActionModal();
  }

  updatePostcardTemplateId(postcard_template_id) {
    this.setState(
      { postcard_template_id: postcard_template_id },
      function() {
        this.saveStep();
      }.bind(this)
    );
  }

  handleChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    if (
      name == "step_action" &&
      value == "sms" &&
      this.props.rookeryEnabled == false
    ) {
      e.preventDefault();
      const ToastrSMSWarning = () => {
        return (
          <p>
            You must first enable text messaging to send SMS messages in your
            workflows.
            <br />
            <br />
            <a
              href="https://leads.realgeeks.com/preferences/text_messaging"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here to enable text messaging.
            </a>
          </p>
        );
      };
      const options = {
        icon: "warning",
        status: "warning",
        component: <ToastrSMSWarning />
      };
      toastr.info("Warning", options);
    } else {
      this.setAndSaveStep(e);
    }
  }

  setAndSaveStep(e) {
    let { name, value } = e.target;
    // Set default purpose to 'Call', and medium_assignee to 'assigned_agent'
    if (name == "medium" && value == "manual") {
      if (
        this.state.medium_purpose == undefined ||
        this.state.medium_purpose == ""
      ) {
        this.setState({ medium_purpose: "Call", medium_assignee: 'assigned_agent' });
      }
    }

    if (name == "medium_pause") {
      value = e.target.checked;
    }

    this.setState(
      { [name]: value },
      function() {
        this.delayedCallback(this.saveStep.bind(this));
      }.bind(this)
    );
  }

  templateOptions() {
    if (this.props.templates) {
      let categories = [];
      this.props.templates.map(template => {
        if (
          categories.indexOf(template.email_template_category_name) == -1 &&
          template.email_template_category_name != null
        ) {
          categories.push(template.email_template_category_name);
        }
      });
      categories.sort();
      categories.push(null);
      let optgroups = [];
      optgroups.push(
        <option value="">Choose template -or- Add new one</option>
      );
      categories.map(category => {
        let displayCategory = category == null ? "Uncategorized" : category;
        let options = this.props.templates.map(template => {
          if (template.email_template_category_name == category) {
            let selected =
              this.state.email_template_id == template.id ? true : false;
            return (
              <option key={template.id} value={template.id} selected={selected}>
                {template.name}
              </option>
            );
          }
        });
        optgroups.push(<optgroup label={displayCategory}>{options}</optgroup>);
      });
      return optgroups;
    }
  }

  smsTemplateOptions() {
    if (this.props.smsTemplates) {
      let categories = [];
      this.props.smsTemplates.map(template => {
        if (
          categories.indexOf(template.sms_template_category_name) == -1 &&
          template.sms_template_category_name != null
        ) {
          categories.push(template.sms_template_category_name);
        }
      });
      categories.sort();
      categories.push(null);
      let optgroups = [];
      optgroups.push(
        <option value="">Choose template -or- Add new one</option>
      );
      categories.map(category => {
        let displayCategory = category == null ? "Uncategorized" : category;
        let options = this.props.smsTemplates.map(template => {
          if (template.sms_template_category_name == category) {
            let selected =
              this.state.sms_template_id == template.id ? true : false;
            return (
              <option key={template.id} value={template.id} selected={selected}>
                {template.name}
              </option>
            );
          }
        });
        optgroups.push(<optgroup label={displayCategory}>{options}</optgroup>);
      });
      return optgroups;
    }
  }

  rvmTemplateOptions() {
    if (this.props.rvmTemplates) {
      let categories = [];
      this.props.rvmTemplates.map(template => {
        if (
          categories.indexOf(template.rvm_template_category_name) == -1 &&
          template.rvm_template_category_name != null
        ) {
          categories.push(template.rvm_template_category_name);
        }
      });
      categories.sort();
      categories.push(null);
      let optgroups = [];
      optgroups.push(
        <option value="">Choose template -or- Add new one</option>
      );
      categories.map(category => {
        let displayCategory = category == null ? "Uncategorized" : category;
        let options = this.props.rvmTemplates.map(template => {
          if (template.rvm_template_category_name == category) {
            let selected =
              this.state.rvm_template_id == template.id ? true : false;
            return (
              <option key={template.id} value={template.id} selected={selected}>
                {template.name}
              </option>
            );
          }
        });
        optgroups.push(<optgroup label={displayCategory}>{options}</optgroup>);
      });
      return optgroups;
    }
  }

  postcardTemplateOptions() {
    if (this.props.postcard_templates) {
      let options = this.props.postcard_templates.map(template => {
        let selected =
          this.state.postcard_template_id == template.id ? true : false;
        return (
          <option key={template.id} value={template.id} selected={selected}>
            {template.name}
          </option>
        );
      });
      return options;
    }
  }

  delayValueOptions() {
    let options = Array(366)
      .fill()
      .map((_, i) => {
        let count = i;
        return (
          <option key={count} value={count}>
            {count}
          </option>
        );
      });
    return options;
  }

  agentOptions() {
    if (this.props.senders) {
      let options = this.props.senders.map(agent => {
        let selected = agent.name == this.state.medium_assignee ? true : false;
        return (
          <option key={agent.id} value={agent.id}>
            {agent.name}
          </option>
        );
      });
      options.unshift(
        <option
          key="1111111"
          value="assigned_agent"
          selected={
            this.state.medium_assignee == "assigned_agent" ? "selected" : ""
          }
        >
          Assigned Agent
        </option>
      );
      return options;
    }
  }

  typeOptions() {
    let options = [
      <option
        key="email"
        value="email"
        selected={this.state.medium == "email" ? "selected" : ""}
      >
        Email
      </option>
    ];
    options.push(
      <option
        key="manual"
        value="manual"
        selected={this.state.medium == "task" ? "selected" : ""}
      >
        Follow-up
      </option>
    );
    options.push(
      <option
        key="sms"
        value="sms"
        selected={this.state.medium == "sms" ? "selected" : ""}
      >
        SMS
      </option>
    );
    if ( Constants.BETA_SITE_UUIDS.includes(localStorage.getItem('lastSiteUUID'))) {
      options.push(
        <option
          key="rvm"
          value="rvm"
          selected={this.state.medium == "rvm" ? "selected" : ""}
        >
          Voicemail
        </option>
    );
    }
    if (
      localStorage.getItem('lastSiteUUID') == "42cc1d70-c912-11e0-8a75-001cc45fad02"
    ) {
      options.push(
        <option
          key="postcard"
          value="postcard"
          selected={this.state.medium == "postcard" ? "selected" : ""}
        >
          Postcard
        </option>
      );
      options.push(
        <option
          key="Video Message"
          value="Video Message"
          selected={this.state.medium == "vid_msg" ? "selected" : ""}
        >
          Video Message
        </option>
      );
    }
    return options;
  }

  render() {
    const { stepEnabled } = this.props;
    return (
      <div>
        <form className="step_form" id={"step_form_" + this.props.id}>
          <div className="row">
            <div className="form-group col-xs-1">
              <i className="fa fa-arrows fa-2x m-r-5 draggable-arrows" />
            </div>
            <div className="form-group col-xs-2 step_delay_group">
              <label className="step_delay_label">
                {this.props.formKey != 0 ? "and then " : ""}
                Wait
              </label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_delay_amt m-r-5"
                labelClassName=""
                wrapperClassName=""
                value={this.state.delay_value}
                name="delay_value"
                onChange={this.handleChange.bind(this)}
              >
                {this.delayValueOptions()}
              </FormControl>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_delay_unit"
                labelClassName=""
                wrapperClassName=""
                value={this.state.delay_unit}
                name="delay_unit"
                onChange={this.handleChange.bind(this)}
              >
                <option value="minutes">minutes</option>
                <option value="hours">hours</option>
                <option value="days">days</option>
                <option value="weeks">weeks</option>
                <option value="months">months</option>
                <option value="years">years</option>
              </FormControl>
            </div>
            <div className="form-group hide">
              <label className="step_delay_label">Office Hrs?</label>
              <input
                type="checkbox"
                className="use_office_hours"
                labelClassName=""
                wrapperClassName=""
                value={this.state.office_hours}
                name="office_hours"
                onChange={this.handleChange.bind(this)}
              />
            </div>

            <div className="form-group col-xs-1 m-r-5 step_action_group">
              <label className="medium_label">Action</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control action_type"
                labelClassName=""
                wrapperClassName=""
                value={this.state.medium}
                name="medium"
                onChange={this.handleChange.bind(this)}
              >
                {this.typeOptions()}
              </FormControl>
            </div>

            <div
              className={
                "form-group col-xs-7 step_action_group " +
                (this.state.medium == "email" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Template</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_action step_template"
                labelClassName=""
                wrapperClassName=""
                value={this.state.email_template_id}
                name="email_template_id"
                onChange={this.handleChange.bind(this)}
              >
                {this.templateOptions()}
              </FormControl>
              <button
                className={`btn btn-xs pull-right ${
                  stepEnabled
                    ? "edit_action_btn btn-inverse"
                    : "view_action_btn btn-primary"
                } ${this.state.email_template_id ? "" : "invisible"}`}
                onClick={this.openEditAction.bind(this)}
              >
                Edit
              </button>

              <button
                className="btn btn-xs btn-inverse pull-right new_action_btn"
                onClick={this.openNewAction.bind(this)}
              >
                New
              </button>
            </div>

            <div
              className={
                "form-group col-xs-1 m-r-5 step_action_group " +
                (this.state.medium == "manual" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Purpose</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_purpose"
                labelClassName=""
                wrapperClassName=""
                value={this.state.medium_purpose}
                name="medium_purpose"
                onChange={this.handleChange.bind(this)}
              >
                <option value="Call">Call</option>
                <option value="BombBomb">BombBomb</option>
                <option value="Email">Email</option>
                <option value="Meeting">Meeting</option>
                <option value="Other">Other</option>
                <option value="Text">Text</option>
              </FormControl>
            </div>
            <div
              className={
                "form-group col-xs-4 m-r-5 step_action_group " +
                (this.state.medium == "manual" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Title</label>
              <FormControl
                componentClass="input"
                type="text"
                className="form-control step_title"
                labelClassName=""
                wrapperClassName=""
                value={this.state.medium_title}
                name="medium_title"
                onChange={this.handleChange.bind(this)}
              />
              <button
                className={`btn btn-xs btn-inverse pull-right task_details_btn`}
                onClick={this.openTaskEditAction.bind(this)}
              >
                Details
              </button>
            </div>
            <div
              className={
                "form-group col-xs-1 m-r-5 step_action_group " +
                (this.state.medium == "manual" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Assignee</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_assignee"
                labelClassName=""
                wrapperClassName=""
                value={this.state.medium_assignee}
                name="medium_assignee"
                onChange={this.handleChange.bind(this)}
              >
                {this.agentOptions()}
              </FormControl>
            </div>
            <div
              className={
                "form-group col-xs-1 step_action_group " +
                (this.state.medium == "manual" ? "" : "hidden")
              }
            >
              <label className="step_action_label">
                Pause
                <button
                  bsStyle="default"
                  className="btn btn-sm btn-primary help_icon_smaller"
                  onClick={this.props.handleTooltipForPause.bind(
                    this,
                    this.props.id
                  )}
                >
                  ?
                </button>
              </label>
              <input
                type="checkbox"
                className="pause_checkbox"
                labelClassName=""
                wrapperClassName=""
                checked={this.state.medium_pause}
                name="medium_pause"
                onChange={this.handleChange.bind(this)}
              />
            </div>

            <div
              className={
                "form-group col-xs-7 step_action_group " +
                (this.state.medium == "postcard" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Template</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_action step_template"
                labelClassName=""
                wrapperClassName=""
                value={this.state.postcard_template_id}
                name="postcard_template_id"
                onChange={this.handleChange.bind(this)}
              >
                {this.postcardTemplateOptions()}
              </FormControl>
            </div>

            <div
              className={
                "form-group col-xs-7 step_action_group " +
                (this.state.medium == "sms" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Template</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_action step_template"
                labelClassName=""
                wrapperClassName=""
                value={this.state.sms_template_id}
                name="sms_template_id"
                onChange={this.handleChange.bind(this)}
              >
                {this.smsTemplateOptions()}
              </FormControl>
              <button
                className={`btn btn-xs pull-right ${
                  stepEnabled
                    ? "edit_action_btn btn-inverse"
                    : "view_action_btn btn-primary"
                } ${this.state.sms_template_id ? "" : "invisible"}`}
                onClick={this.openSMSEditAction.bind(this)}
              >
                Edit
              </button>
              <button
                className="btn btn-xs btn-inverse pull-right new_action_btn"
                onClick={this.openSMSNewAction.bind(this)}
              >
                New
              </button>
            </div>

            <div
              className={
                "form-group col-xs-7 step_action_group " +
                (this.state.medium == "rvm" ? "" : "hidden")
              }
            >
              <label className="step_action_label">Template</label>
              <FormControl
                componentClass="select"
                type="select"
                className="form-control step_action step_template"
                labelClassName=""
                wrapperClassName=""
                value={this.state.rvm_template_id}
                name="rvm_template_id"
                onChange={this.handleChange.bind(this)}
              >
                {this.rvmTemplateOptions()}
              </FormControl>
              <button
                className={`btn btn-xs pull-right ${
                  stepEnabled
                    ? "edit_action_btn btn-inverse"
                    : "view_action_btn btn-primary"
                } ${this.state.rvm_template_id ? "" : "invisible"}`}
                onClick={this.openRVMEditAction.bind(this)}
              >
                Edit
              </button>
              <button
                className="btn btn-xs btn-inverse pull-right new_action_btn"
                onClick={this.openRVMNewAction.bind(this)}
              >
                New
              </button>
            </div>

          </div>
        </form>

        <Modal
          show={this.state.showEditActionModal}
          onHide={this.closeEditActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">Edit Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TemplatesEditInline
              match={this.props.match}
              email_template_id={this.state.email_template_id}
              handleUpdateEmailId={this.updateEmailTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showNewActionModal}
          onHide={this.closeNewActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">New Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TemplatesNewInline
              match={this.props.match}
              handleUpdateEmailId={this.updateEmailTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showSMSEditActionModal}
          onHide={this.closeSMSEditActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Edit SMS Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SMSTemplatesEditInline
              match={this.props.match}
              sms_template_id={this.state.sms_template_id}
              handleUpdateSMSId={this.updateSMSTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showSMSNewActionModal}
          onHide={this.closeSMSNewActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              New SMS Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SMSTemplatesNewInline
              match={this.props.match}
              handleUpdateSMSId={this.updateSMSTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showRVMEditActionModal}
          onHide={this.closeRVMEditActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Edit Voicemail Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RVMTemplatesEditInline
              match={this.props.match}
              rvm_template_id={this.state.rvm_template_id}
              handleUpdateRVMId={this.updateRVMTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>


        <Modal
          show={this.state.showRVMNewActionModal}
          onHide={this.closeRVMNewActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              New Voicemail Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RVMTemplatesNewInline
              match={this.props.match}
              handleUpdateRVMId={this.updateRVMTemplateId.bind(this)}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showTaskEditActionModal}
          onHide={this.closeTaskEditActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={false}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Task Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control step_title task_details_description"
              labelClassName=""
              wrapperClassName=""
              value={this.state.medium_description}
              name="medium_description"
              onChange={this.handleChange.bind(this)}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default StepForm;
